import TextField from "@/components/layouts/History/TextField";
import { useProducts } from "@/entities/settings/hooks";
import { find } from "lodash";

interface Props {
  value: string;
}

const ProductName: React.FC<Props> = ({ value }) => {
  const products = useProducts().data?.products ?? [];
  const product = find(products, (product) => product.id === value);
  return <TextField>{product?.name || ""}</TextField>;
};

export default ProductName;
